<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const info = computed(() => store.state.appInfo);

const emit = defineEmits(['confirm']);

const handleConfirm = () => {
  emit('confirm');
};
</script>
<template>
  <div class="ios-privacy">
    <div class="title">
      <h2>
        {{ info.language_list.privacy }}
        <i class="iconfont icon-fanye"></i>
      </h2>
    </div>
    <div>
      {{ info.language_list.the_developer }}{{ info.language_list.author
      }}{{ info.language_list.indicated }}&nbsp;&nbsp;<a
        @click="handleConfirm"
        >{{ info.language_list.privacy_policy }}</a
      >
    </div>
    <div class="items">
      <i class="iconfont icon-wode"></i>
      <h3>{{ info.language_list.dataused }}</h3>
      <div class="desc">{{ info.language_list.following_data }}</div>
      <div class="flex align-center justify-between items-list">
        <div class="flex align-center">
          <i class="iconfont icon-tupianji_B"></i>
          <span>{{ info.language_list.user_content }}</span>
        </div>
        <div class="flex align-center">
          <i class="iconfont icon-wodexinxi"></i>
          <span>{{ info.language_list.identifiers }}</span>
        </div>
      </div>
    </div>
    <div class="items items-2">
      <i class="iconfont icon-icon-heimingdan"></i>
      <h3>{{ info.language_list.data_not_linked }}</h3>
      <div class="desc">{{ info.language_list.notlinked }}</div>
      <div class="flex align-center justify-between items-list">
        <div class="flex align-center">
          <i class="iconfont icon-xitong-weizhipeizhi"></i>
          <span>{{ info.language_list.location }}</span>
        </div>
        <div class="flex align-center">
          <i class="iconfont icon-dangerLevel"></i>
          <span>{{ info.language_list.usage_data }}</span>
        </div>
      </div>
      <div class="flex align-center justify-between items-list">
        <div class="flex align-center">
          <i class="iconfont icon-shezhi"></i>
          <span>{{ info.language_list.diagnostics }}</span>
        </div>
      </div>
    </div>
    <div class="text">
      {{ info.language_list.privacy_practices }}
      <a @click="handleConfirm"> {{ info.language_list.learnmore }}</a>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.ios-privacy {
  color: #000;
  a {
    color: var(--main-color);
  }
  .title {
    .iconfont {
      color: #000;
    }
    h2 {
      margin: 20px 0 8px 0;
    }
  }
  .items {
    padding: 17px 17px 10px 17px;
    width: 100%;
    border-radius: 12px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.3);
    box-sizing: border-box;
    margin: 18px 0;
    text-align: center;
    .icon-wodexinxi {
      font-size: 18px !important;
    }
    .iconfont {
      font-size: 14px;
      margin-right: 5px;
    }
    .icon-wode,
    .icon-icon-heimingdan {
      font-size: 24px;
      color: var(--main-color);
    }
    h3 {
      margin: 12px 0 8px 0;
    }
    .desc {
      color: #555;
      font-size: 10px;
      line-height: 20px;
    }
    .items-list {
      color: #333;
      .iconfont {
        color: #333;
        vertical-align: middle;
      }
      div {
        width: 50%;
        text-align: left;
        margin: 6px 0;
        font-size: 10px;
      }
    }
  }
  .text {
    color: #666;
  }
}
</style>
